var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.puchipuchi_een{fill:#111918;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "puchipuchi_een",
    d: "M30.838,18.634h0.002l-2.107-9.173C28.081,7.458,26.221,6,24,6c-1.63,0-3.065,0.792-3.977,2h-8.045 C11.065,6.792,9.63,6,8,6C5.779,6,3.919,7.458,3.267,9.461L1.16,18.633h0.002C1.06,19.073,1,19.529,1,20c0,3.314,2.686,6,6,6 c2.611,0,4.827-1.671,5.651-4h6.698c0.825,2.329,3.04,4,5.651,4c3.314,0,6-2.686,6-6C31,19.529,30.94,19.073,30.838,18.634z M10,16 H9v1c0,0.552-0.447,1-1,1s-1-0.448-1-1v-1H6c-0.553,0-1-0.448-1-1s0.447-1,1-1h1v-1c0-0.552,0.447-1,1-1s1,0.448,1,1v1h1 c0.553,0,1,0.448,1,1S10.553,16,10,16z M23,17c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S23.552,17,23,17z M23,14 c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S23.552,14,23,14z M26,17c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1 S26.552,17,26,17z M26,14c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S26.552,14,26,14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.f661b863bb0f04860b242aa1e3b99bf3.svg";
export { ForwardRef as ReactComponent };